<template>

  <modal
      width="400px"
      :can-be-dismissed="false"
      ref="guestCountModal"
      :hideFooter="true"
      v-if="!isMobile()"
  >
    <template slot="header">
      <div class="order-type-header w-100">
        <div class="card ">
          <div class="card-body ">
            <h3 class="card-title text-center">Table {{ table }}</h3>
            <form class="mt-3" @submit.prevent="handleSubmit()">
              <div class="form-group">
                <input
                    type="number"
                    class="form-control text-center"
                    placeholder="No. of People"
                    v-model="count"
                    @click="handleKeypress()"
                />
              </div>
              <div class="alert alert-danger mt-2" role="alert" v-show="error">
                {{ error }}
              </div>
              <div
                  v-if="count && (count > getGuestsPerTableMax)"
                  class="alert alert-info text-center"
                  role="alert"
              >
                Value entered is greater than {{ getGuestsPerTableMax }}
              </div>
              <div class="container">
                <div class="row">
                  <!--                    array of keypad buttons-->
                  <div class="col-3" v-for="n in keypadNumbers" :key="n">
                    <button
                        type="button"
                        class="btn btn-secondary btn-lg btn-block mt-3 br-5"
                        :class="count === n ? 'bg-black' : 'btn-outline-dark'"
                        @click="handleClick(n)"
                    >
                      {{ n }}
                    </button>
                  </div>

                </div>
              </div>
              <button :disabled="!count" type="submit" class="btn btn-lg btn-block mt-5 br-5" :style="btnStyle">
                Start Order
              </button>
            </form>
          </div>
        </div>
      </div>
    </template>
  </modal>

  <vue-bottom-sheet v-else ref="guestCountBottomSheet" :rounded="true" @closed="false" :swipe-able="false" :click-to-close="false" :overlay="!activePopup"  :background-clickable="activePopup">

            <div class="d-flex justify-content-center" >
             <div class="px-4 pt-2 w-100" >

               <h3 class="card-title text-center">Table {{ table }}</h3>
               <form class="mt-3" @submit.prevent="handleSubmit()">
                 <div class="form-group">
                   <input
                       type="number"
                       class="form-control text-center"
                       placeholder="No. of People"
                       v-model="count"
                       @click="handleKeypress()"
                   />
                 </div>
                 <div class="alert alert-danger mt-2" role="alert" v-show="error">
                   {{ error }}
                 </div>
                 <div
                     v-if="count && (count > getGuestsPerTableMax)"
                     class="alert alert-info text-center"
                     role="alert"
                 >
                   Value entered is greater than {{ getGuestsPerTableMax }}
                 </div>
                 <!--                <div class="container">-->
                 <!--                  <div class="row">-->
                 <!--&lt;!&ndash;                    array of keypad buttons&ndash;&gt;-->
                 <!--                    <div class="col-3" v-for="n in keypadNumbers" :key="n">-->
                 <!--                      <button-->
                 <!--                        type="button"-->
                 <!--                        class="btn btn-secondary btn-lg btn-block mt-3 br-5"-->
                 <!--                        :class="count === n ? 'bg-black' : 'btn-outline-dark'"-->
                 <!--                        @click="handleClick(n)"-->
                 <!--                      >-->
                 <!--                        {{ n }}-->
                 <!--                      </button>-->
                 <!--                    </div>-->

                 <!--                  </div>-->
                 <!--                </div>-->
                 <button :disabled="!count" type="submit" class="btn btn-lg btn-block mt-2 br-5" :style="btnStyle">
                   Start Order
                 </button>
               </form>
             </div>
    </div>
  </vue-bottom-sheet>
  </template>

  <script>
  import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
  import modal from '../modal.vue';
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: 'GuestCount',
    components: {
      VueBottomSheet,
      modal
    },
    data() {
      return {
        error: '',
        table: '',
        count: '',
      }
    },
    mounted() {
      const that = this;
      if (this.$route.query) {
        that.table = this.$route.query.table || sessionStorage.getItem('table')
      }

      if(this.isMobile()){
        this.$refs.guestCountBottomSheet.open();
        return
      }
      this.$refs.guestCountModal.hideModal(true);

    },
    methods: {
      ...mapActions(['setPeople']),
      handleClick(num) {
        this.count = num;
        this.error = '';
      },
      handleSubmit() {
        if (this.count && this.count == 0) {
          this.error = 'Please enter valid count';
          return;
        }
        this.setPeople(this.count);
        if(this.isMobile()){
          this.$refs.guestCountBottomSheet.close();
          return;
        }

        this.$refs.guestCountModal.hideModal(true);
      },
      handleKeypress() {
        this.error = '';
      },
      random() {
        return Math.floor(Math.random() * 1000) + 1
      },
      range(start, stop, step){
        if(typeof stop=='undefined'){
          // one param defined
          stop = start;
          start = 0;
        }
       return Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
      },
      close() {
        this.$refs.guestCountBottomSheet.close();
      }
    },
    computed: {
      ...mapGetters(['getGuestsPerTableMax', 'getGuestsPerTableMin', 'desktopStyles', 'mobileStyles', 'activePopup']),
      btnStyle() {
        return this.isMobile() ? this.mobileStyles.btn : this.desktopStyles.btn;
      },
      // keypadNumbers() {
      // //   return array of numbers between range
      //   if(!this.getGuestsPerTableMax || !this.getGuestsPerTableMin) {
      //     return [];
      //   }
      //   return this.range(this.getGuestsPerTableMin, this.getGuestsPerTableMax, 1);
      //
      // }
    }
  }
  </script>

  <style>
  .form-control::-webkit-input-placeholder {
    color: black!important;
    text-align: center;
    font-size: large;
  }
  </style>
